<app-custom-button [id]="idButton" [icon]="icon" [label]="label" [severity]="'success'" [disabled]="disabled"
  (onClick)="show()" [width]="'6rem'"></app-custom-button>